export const getBlockData = (state, id, module, blockKey) =>
    state.getIn(['ui', 'modules', module, 'workspace', id, 'blocks', blockKey, 'data'])
export const getBlockCustomData = (state, id, module, blockKey) =>
    state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'customData'])
export const getBlockCurrentStandard = (state, id, module, blockKey) =>
    state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'customData', 'results', 'currentStandard'])
export const getBlockCurrentCashFlow = (state, id, module, blockKey) =>
    state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'customData', 'cashFlow', 'currentStandard'])
